export const FULFILLMENT_INTEGRATION_TYPES_ALLOW_SHIP = ['cymbio_api'];
